import { useContext, useMemo } from "react";
import JournalServices from "../services/journalServices";
import { AuthContext } from "../contexts/AuthContext";

const useJournal = () => {
  const { api } = useContext(AuthContext);
  const service = useMemo(() => new JournalServices(api), [api]);

  const getAllJournal = () => {
    return service.getAll();
  };

  const getOneJournal = (id) => {
    return service.getOne(id);
  };

  const createJournal = (reponse) => {
    return service.create(reponse);
  };

  const updateJournal = (id, reponse) => {
    return service.update(id, reponse);
  };

  return {
    getAllJournal,
    getOneJournal,
    createJournal,
    updateJournal,
  };
};

export default useJournal;